import {
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';
import { Feedback } from '../../pages/Feedback';
import { Header } from '@/components/Header';

export const Route = createFileRoute('/_authenticated/account/feedback')({
  component: FeedbackPage,
});

function FeedbackPage() {
  const router = useRouterState();
  const childRouteIds = new Set([
    '/_authenticated/_admin/admin/manage-users/import',
  ]);
  const isChildRoute = router.matches.some((match) =>
    childRouteIds.has(match.routeId)
  );

  // Render child routes (import, etc.)
  if (isChildRoute) {
    return <Outlet />;
  }

  return (
    <>
      <Header enableBack additionalClasses="bg-slate-700" />
      <Feedback />
    </>
  );
}

